module.exports = __webpack_public_path__ + "static/media/icn-shirt.4943a93d.svg";